import React, { useEffect } from 'react';
import { useApp } from '../context/AppContext';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const NotificationContainerWrapper = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;
`;

const NotificationItem = styled.div`
  background: ${props => {
    switch (props.type) {
      case 'success': return '#28a745';
      case 'error': return '#dc3545';
      case 'warning': return '#ffc107';
      case 'info': 
      default: return '#17a2b8';
    }
  }};
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: ${slideIn} 0.3s ease-out;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateX(-5px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
  
  &.removing {
    animation: ${slideOut} 0.3s ease-out;
  }
`;

const NotificationMessage = styled.div`
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 4px;
`;

const NotificationTime = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

export default function NotificationContainer() {
  const { state, dispatch } = useApp();

  // Автоматическое удаление уведомлений через 5 секунд
  useEffect(() => {
    state.notifications.forEach(notification => {
      if (!notification.persistent) {
        const timer = setTimeout(() => {
          dispatch({
            type: 'REMOVE_NOTIFICATION',
            payload: { id: notification.id }
          });
        }, 5000);

        return () => clearTimeout(timer);
      }
    });
  }, [state.notifications, dispatch]);

  const handleNotificationClick = (notificationId) => {
    dispatch({
      type: 'REMOVE_NOTIFICATION',
      payload: { id: notificationId }
    });
  };

  return (
    <NotificationContainerWrapper>
      {state.notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          type={notification.type}
          onClick={() => handleNotificationClick(notification.id)}
        >
          <NotificationMessage>
            {notification.message}
          </NotificationMessage>
          <NotificationTime>
            {new Date(notification.timestamp).toLocaleTimeString('ru-RU', {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </NotificationTime>
        </NotificationItem>
      ))}
    </NotificationContainerWrapper>
  );
}
